import ApiService from './ApiService';

class MagazineApi extends ApiService {
    constructor() {
        super('magazines');
    }

    getMagazines(params?: any) {
        return this.get('', params);
    }

    getMagazineDetail(id: string) {
        return this.get(id);
    }

    getMagazinePublications(id: string, params?: any) {
        return this.get(`${id}/publications`, params);
    }
}

const magazineApi = new MagazineApi();
export default magazineApi;
